import { __read, __values } from "tslib";
import { callBoth } from "./call-both";
/**
 * 透传 props 中的事件处理器，可以从 occupiedProps 指定已有的处理函数，会同时调用
 *
 * @param props 组件 Props
 * @param occupiedProps 已被使用的事件 Props
 */
export function mergeEventProps(props, occupiedProps) {
    var e_1, _a, e_2, _b;
    if (occupiedProps === void 0) { occupiedProps = {}; }
    var mergedProps = {};
    try {
        for (var _c = __values(Object.entries(props)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), key = _e[0], prop = _e[1];
            if (/^on(Mouse|Touch|Key|Drag|Drop|Click|DoubleClick|ContextMenu|Focus|Blur).*/.test(key) &&
                typeof prop === "function") {
                mergedProps[key] = prop;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _f = __values(Object.entries(occupiedProps)), _g = _f.next(); !_g.done; _g = _f.next()) {
            var _h = __read(_g.value, 2), key = _h[0], handler = _h[1];
            if (typeof mergedProps[key] === "function") {
                mergedProps[key] = callBoth(handler, mergedProps[key]);
            }
            else {
                mergedProps[key] = handler;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mergedProps;
}
//# sourceMappingURL=merge-event-props.js.map